import React, { useState, useEffect, useCallback } from 'react';
import Header from './components/Header';
import Stats from './components/Stats';
import AddFAQForm from './components/AddFAQForm';
import FAQList from './components/FAQList';
import EditModal from './components/EditModal';
import Alert from './components/Alert';
import { faqAPI } from './services/api';

function App() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(null);
  const [editingFAQ, setEditingFAQ] = useState(null);

  const showAlert = useCallback((message, type) => {
    setAlert({ message, type });
    setTimeout(() => setAlert(null), 5000);
  }, []);

  const loadAllFAQs = useCallback(async () => {
    try {
      setLoading(true);
      const data = await faqAPI.getAll();
      setFaqs(data);
    } catch (error) {
      showAlert('Ошибка загрузки FAQ: ' + error.message, 'error');
    } finally {
      setLoading(false);
    }
  }, [showAlert]);

  useEffect(() => {
    loadAllFAQs();
  }, [loadAllFAQs]);

  const searchFAQs = async (query) => {
    if (!query.trim()) {
      loadAllFAQs(); 
      return;
    } 
 
    try {
      setLoading(true); 
      const data = await faqAPI.search(query);
      setFaqs(data);
    } catch (error) {
      showAlert('Ошибка поиска: ' + error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  const addFAQ = async (faqData) => {
    try {
      await faqAPI.create(faqData);
      showAlert('FAQ успешно добавлен!', 'success');
      loadAllFAQs();
    } catch (error) {
      showAlert('Ошибка добавления FAQ: ' + error.message, 'error');
    }
  };

  const updateFAQ = async (id, faqData) => {
    try {
      await faqAPI.update(id, faqData);
      showAlert('FAQ успешно обновлен!', 'success');
      setEditingFAQ(null);
      loadAllFAQs();
    } catch (error) {
      showAlert('Ошибка обновления FAQ: ' + error.message, 'error');
    }
  };

  const deleteFAQ = async (id) => {
    if (!window.confirm('Вы уверены, что хотите удалить этот FAQ?')) {
      return;
    }

    try {
      await faqAPI.delete(id);
      showAlert('FAQ удален!', 'success');
      loadAllFAQs();
    } catch (error) {
      showAlert('Ошибка удаления FAQ: ' + error.message, 'error');
    }
  };

  const handleEditFAQ = (faq) => {
    setEditingFAQ(faq);
  };

  const closeEditModal = () => {
    setEditingFAQ(null);
  };

  return (
    <div className="container">
      <Header />
      
      {alert && <Alert message={alert.message} type={alert.type} />}
      
      <Stats faqs={faqs} />
      
      <AddFAQForm onAddFAQ={addFAQ} />
      
      <FAQList 
        faqs={faqs} 
        loading={loading} 
        onEdit={handleEditFAQ}
        onDelete={deleteFAQ}
        onSearch={searchFAQs}
        onShowAll={loadAllFAQs}
      />
      
      {editingFAQ && (
        <EditModal
          faq={editingFAQ}
          onSave={updateFAQ}
          onClose={closeEditModal}
        />
      )}
    </div>
  );
}

export default App; 